function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moduleStyles from '@dtsl/css-radio-button/dist/index.module.css';
export const RadioButton = _ref => {
  let {
    identifier,
    className,
    labelText,
    name,
    value,
    disabled,
    controlStyles,
    ...props
  } = _ref;
  const radioBtnClasses = classNames({
    [moduleStyles['sib-radio-wrapper']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("span", {
    className: radioBtnClasses
  }, /*#__PURE__*/React.createElement("input", _extends({
    className: moduleStyles['sib-radio__input'],
    type: "radio",
    id: identifier,
    name: name,
    value: value,
    disabled: disabled
  }, props)), /*#__PURE__*/React.createElement("label", {
    htmlFor: identifier,
    className: moduleStyles['sib-radio']
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      ...controlStyles
    },
    className: moduleStyles['sib-radio__control']
  }), /*#__PURE__*/React.createElement("span", {
    className: moduleStyles['sib-radio__label']
  }, labelText)));
};
RadioButton.propTypes = {
  identifier: PropTypes.string,
  className: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  controlStyles: PropTypes.object
};
RadioButton.defaultProps = {
  identifier: '',
  className: '',
  labelText: '',
  name: '',
  value: '',
  disabled: false,
  controlStyles: {}
};
export default RadioButton;